import React from 'react';
import styled from '@emotion/styled';
import { TagV2 } from '@zola/zola-ui/src/components/Tag/TagV2';

import mickeyIcon from '~/assets/images/magic/Mickey.svg';
import tagBG from '~/assets/images/magic/MagicTagBG.svg';

const StyledTagV2 = styled(TagV2)`
  background: url(${tagBG}) center no-repeat,
    linear-gradient(150.84deg, #5cb7c2 5.16%, #2d246b 100%),
    linear-gradient(90deg, #073b76 0%, #ebafd5 100%);
  color: white;
`;

interface MagicTagProps {
  className?: string;
}

export const MagicTag: React.FC<MagicTagProps> = ({ className }) => (
  <StyledTagV2 className={className} image={{ src: mickeyIcon, alt: 'Mickey icon' }}>
    Extra magical
  </StyledTagV2>
);
